export function NotFoundPage() {
    return <div data-testid="pageNotExists">This Page does not exist !</div>;
}
